var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPassTrain = function SvgPassTrain(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.5,
    d: "M13 3.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.75,
    d: "M13.5 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15 19-2-2"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.5,
    d: "M5.412 15c-.841 0-1.53-.56-1.606-1.33L3.5 10.45v-7C3.5 2.12 4.724 1 6.176 1h7.648C15.276 1 16.5 2.12 16.5 3.45v7l-.306 3.29c-.076.7-.765 1.26-1.606 1.26z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.5,
    d: "M7 3.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.75,
    d: "M6.5 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.538 5h13M3.5 9l6.5.5 6.5-.5M5 19l2-2"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.75,
    d: "M6 18.077h8"
  }))));
};
export default SvgPassTrain;